import { css } from 'linaria';

export const galleryTitle = css`
  && {
    margin-bottom: 24px;
  }
`;

export const catalogGrid = css`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 420px 292px 104px auto;
  width: 100%;
  padding: 0;
  margin-bottom: 32px;
  list-style: none;

  @media (--from-tablet) {
    :nth-child(1),
    :nth-child(3) {
      grid-row: auto / span 2;
    }
  }

  @media (--only-tablet) {
    grid-template-rows: 300px 196px 80px auto;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: 300px 80px auto;
  }
`;

export const newCatalogGrid = css`
  grid-template-columns: 578px 578px;
  grid-template-rows: 462px 266px 172px auto;

  @media (--only-desktop) {
    grid-template-columns: 458px 458px;
    grid-template-rows: 391px 207px 160px auto;
  }

  @media (--only-tablet) {
    grid-template-columns: 318px 318px;
    grid-template-rows: 290px 138px 128px auto;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: 302px 113px auto;
    margin-bottom: 24px;
  }
`;

export const catalogLink = css`
  height: 100%;
`;

export const catalogImageWrapper = css`
  width: 100%;
  height: 309px;

  @media (--to-desktop) {
    height: 200px;
  }
`;

export const catalogFirstImage = css`
  @media (--from-desktop) {
    height: 625px;
  }

  @media (--only-tablet) {
    height: 420px;
  }
`;

export const catalogImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  object-fit: cover;
`;

export const newCatalogImage = css`
  && {
    width: 100%;
    height: 342px;

    @media (--only-desktop) {
      height: 271px;
    }

    @media (--only-tablet) {
      height: 190px;
    }

    @media (--only-mobile) {
      height: 202px;
    }
  }
`;

export const newCatalogFirstImage = css`
  && {
    height: 632px;

    @media (--only-desktop) {
      height: 502px;
    }

    @media (--only-tablet) {
      height: 352px;
    }

    @media (--only-mobile) {
      height: 202px;
    }
  }
`;
